<script setup>
import { onMounted } from 'vue';
import { Button } from '@components';
import { useRouter } from 'vue-router';
import { useTranslation } from '../composables/useTranslation';

const { t } = useTranslation();

onMounted(() => {
    if ( formychat_admin_vars.total_widgets > 0 ) {
        useRouter().push({ name: 'widgets' });
    }
})
</script>
<template>
    <div class=" bg-white w-full p-6 flex items-center justify-center">
        <div class="w-full max-w-sm mx-auto flex flex-col gap-10 items-center justify-center text-center">
            <img :src="Image('welcome.svg')" alt="">
            
            <h3 class="text-xl font-medium text-slate-500">{{ t('empty_widget_message') }}</h3>
            <div class="flex items-center justify-center gap-4">
                <Button outline a href="https://lnk.wppool.dev/9jJWfRk" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" class="fill-current w-3.5" viewBox="0 0 16 16">
                        <path
                            d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z" />
                    </svg> {{ t('watch_tutorial') }}</Button>
                <Button @click.prevent="$router.push({ name: 'widget.edit', params: { widgetId: 'new' } })">
                    <svg xmlns="http://www.w3.org/2000/svg" class="fill-current w-3.5" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>
                    </svg> {{ t('create_floating_widget') }}</Button>
            </div>
        </div>
    </div>
</template>